import BudgetTableRowMobile from './BudgetTableRowMobile';
import { IBudgetItem } from '../BudgetItemsTable';

interface IBudgetItemsTableMobileProps {
  items: IBudgetItem[];
  proposalItems?: IBudgetItem[];
  isExternalService?: boolean;
  isEditMode?: boolean;
  isPackageItemsLoading?: boolean;
  showDiscountColumn?: boolean;
  onItemChange?: (index: number, field: keyof IBudgetItem, value: string | number | boolean | undefined) => void;
  onRemoveItem?: (index: number) => void;
}

const MOBILE_SKELETON_ROWS = 4;

const BudgetItemsTableMobile = (props: IBudgetItemsTableMobileProps) => {
  const showDiscountColumn = props.showDiscountColumn !== false;

  return (
    <div className="mb-3 w-full">
      <div className="flex flex-col gap-3">
        {props.isPackageItemsLoading
          ? Array.from({ length: MOBILE_SKELETON_ROWS }).map((_, rowIndex) => (
              <div
                key={`skeleton-mobile-${rowIndex}`}
                className="rounded border border-gray-200 p-4 space-y-3 bg-white"
              >
                <div className="h-3 w-1/4 rounded bg-gray-200 animate-pulse" />
                <div className="h-3 w-full rounded bg-gray-200 animate-pulse" />
                <div className="h-3 w-full max-w-[90%] rounded bg-gray-200 animate-pulse" />
                <div className="flex gap-2 pt-1">
                  <div className="h-8 flex-1 rounded bg-gray-200 animate-pulse" />
                  <div className="h-8 w-20 rounded bg-gray-200 animate-pulse" />
                </div>
              </div>
            ))
          : props.items.map((item, index) => {
              const originalItem =
                props.proposalItems?.[index]?.ref === item.ref
                  ? props.proposalItems[index]
                  : props.proposalItems?.find(
                      (proposalItem, proposalIndex) =>
                        proposalItem.ref === item.ref && proposalIndex === index
                    );

              return (
                <BudgetTableRowMobile
                  key={`item-${item.ref}-${index}`}
                  item={item}
                  originalItem={originalItem}
                  index={index}
                  isExternalService={props.isExternalService}
                  isEditMode={props.isEditMode}
                  onItemChange={props.onItemChange}
                  onRemoveItem={props.onRemoveItem}
                  showDiscountColumn={showDiscountColumn}
                />
              );
            })}
      </div>
    </div>
  );
};

export default BudgetItemsTableMobile;
